'use strict';

import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import {StructureView} from '../ui/StructureView.js';
import * as iiifUtil from '../util/IIIFUtil.js';
import * as domItem from '../viewer/DomItem.js';

const privateMap = util.createPrivateMapper();

export class TocView extends UiComponent {
  constructor(domEl, options){
    super(domEl);
    options = options ? options : {};
    const pv = privateMap(this);

    pv.structureView = new StructureView(options.structureView.domEl, options.structureView.options);
    this.active = false;
  }

  set structures(structures) {
    const pv = privateMap(this);
    pv.structureView.reset();
    if (!structures || !structures.length) {
      this.active = false;
      return;
    }
    structures.forEach(struct => {
      pv.structureView.addNode(struct.parentId, struct.id, struct.data);
    })
    this.active = true;
  }

  selectIds(ids){
    const pv = privateMap(this);
    pv.structureView.selectIds(ids);
  }
}